// @flow

import reducer from 'app/settings/reducer';
import routes from 'app/settings/routes';

export default {
  reducers: {
    settings: reducer,
  },
  routes,
};
